module.exports = __webpack_public_path__ + "static/media/brand-refresh-caret-down.43bc2b0a.svg";